import home from './src/home.vue'
import SecuritySituationRecordList from './src/SecuritySituationRecord/SecuritySituationRecordList.vue' //数据统计列表
import SecuritySituationRecordInfo from './src/SecuritySituationRecord/SecuritySituationRecordInfo.vue' //数据统计详情

let views = {
    home,
    SecuritySituationRecordList,
    SecuritySituationRecordInfo
};

export default views;